import { render, staticRenderFns } from "./PvVisMetaCard.vue?vue&type=template&id=fa5869f0&scoped=true&"
import script from "./PvVisMetaCard.vue?vue&type=script&lang=js&"
export * from "./PvVisMetaCard.vue?vue&type=script&lang=js&"
import style0 from "./PvVisMetaCard.vue?vue&type=style&index=0&id=fa5869f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5869f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
